import React from 'react';
import styles from './updatepassword.module.scss';
import { Input, Grid, Button, Message } from 'semantic-ui-react';
import cx from 'classnames';
import { Link } from 'gatsby';
import arcLogo from '../../images/logo.png';


export default class UpdatePasswordForm extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			email: '',
			password: '',
			confirmed: '',
			token: this.props.tokenId,
			invalidFields: {
				email: false,
				password: false,
				confirmed: false
			}
		};
		
		this.performUpdatepassword = this.performUpdatepassword.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.getValidationError = this.getValidationError.bind(this);
		this.isFieldValid = this.isFieldValid.bind(this);
		this.getErrorMessage = this.getErrorMessage.bind(this);
		this.getSuccessMessage = this.getSuccessMessage.bind(this);
		this.getTokenExpireMessage = this.getTokenExpireMessage.bind(this);
		
	}
	
	performUpdatepassword() {
		
		if (this.state.email === '' && this.state.password === '' && this.state.confirmed === '') {
			this.setState({
				invalidFields: {
					email: true,
					password: true,
					confirmed: true
				}
			});
		} else if (this.state.email === '' && this.state.password !== '' && this.state.confirmed !== '') {
			this.setState({
				invalidFields: {
					email: true,
					password: false,
					confirmed: false
				}
			});
		} else if (this.state.password === '' && this.state.email !== '' && this.state.confirmed !== '') {
			this.setState({
				invalidFields: {
					email: false,
					password: true,
					confirmed: false
				}
			});
		} else if (this.state.confirmed === '' && this.state.email !== '' && this.state.password !== '') {
			this.setState({
				invalidFields: {
					email: false,
					password: false,
					confirmed: true
				}
			});
		} else if (this.state.confirmed !== this.state.password && this.state.email === '') {
			this.setState({
				invalidFields: {
					email: true,
					password: true,
					confirmed: true
				}
			});
		} else if (this.state.confirmed !== this.state.password && this.state.email !== '') {
			this.setState({
				invalidFields: {
					email: false,
					password: true,
					confirmed: true
				}
			});
		} else {
			this.setState({
				invalidFields: {
					email: false,
					password: false,
					confirmed: false
				}
			});
			this.props.updatePassword({
				email: this.state.email,
				password: this.state.password,
				confirmed: this.state.confirmed,
				token: this.state.token
			});
		}
	}
	
	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}
	
	getValidationError(fieldName) {
		
		if (typeof this.props.validationErrors !== 'undefined' && this.props.validationErrors !== null && typeof this.props.validationErrors !== 'string') {
			const fieldIndex = this.props.validationErrors.findIndex((el) => {
				return el.field === fieldName;
			});
			if (fieldIndex > -1) {
				return this.props.validationErrors[fieldIndex].error;
			}
		}
		if (this.state.invalidFields[fieldName]) {
			const fieldNameErr = 'Please insert your valid ' + fieldName;
			return (fieldNameErr);
		}
	}
	
	isFieldValid(fieldName) {
		if (typeof this.props.validationErrors !== 'undefined' && this.props.validationErrors !== null && typeof this.props.validationErrors !== 'string') {
			const fieldIndex = this.props.validationErrors.findIndex((el) => {
				return el.field === fieldName;
			});
			if (fieldIndex > -1) {
				return true;
			} else {
				return false;
			}
		}
		return this.state.invalidFields[fieldName];
	}
	
	getErrorMessage() {
		if (typeof this.props.validationErrors === 'string') {
			return (
				<Message color='red'>{this.props.validationErrors}</Message>
			);
		}
	}
	
	getSuccessMessage() {
		if (this.props.successMessage && this.props.successMessage.verified === 1) {
			return (
				<Message color='green'>Congratulations! You are changed your password successful.</Message>
			);
		}
	}
	
	getTokenExpireMessage() {
		if (typeof this.props.tokenExpireMessage === 'string') {
			return (
				<Message color='red'>{this.props.tokenExpireMessage}</Message>
			);
		}
	}
	
	
	render() {
		return (
			<div className={styles.initialWrap}>
				<div className={styles.centerBox}>
					<div className={cx(styles.centerBoxContent, styles.centerBoxWithBg)}>
						<div className={styles.formMetaContainer}>
							<Grid columns="equal">
								<Grid.Row>
									<Grid.Column className={styles.gridTextCenter}>
										{this.getErrorMessage()}
										{this.getSuccessMessage()}
										{this.getTokenExpireMessage()}
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</div>
						<div className={styles.initialLogo}>
							<img src={arcLogo} alt="ARC"/>
						</div>
						<h1>Update Password?</h1>
						<p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem
							nibh id elit. </p>
						<div className={styles.formWrap}>
							<div
								className={cx(styles.formInputGroup, styles.formInputGroupMarginTop, (this.isFieldValid('email') || this.state.invalidFields.email) && styles.usernameFieldError)}>
								<Input
									name="email"
									placeholder="Email"
									value={this.state.email}
									className={cx(styles.formInputControl)}
									onChange={(event => this.handleInputChange(event))}
								/>
								<div className={styles.errorMessage}>{this.getValidationError('email')}</div>
							</div>
							<div
								className={cx(styles.formInputGroup, styles.formInputGroupMarginTop, (this.isFieldValid('email') || this.state.invalidFields.email) && styles.usernameFieldError)}>
								<Input
									type="password"
									name="password"
									placeholder="Password"
									value={this.state.password}
									className={cx(styles.formInputControl)}
									onChange={(event => this.handleInputChange(event))}
								/>
								<div className={styles.errorMessage}>{this.getValidationError('password')}</div>
							</div>
							<div
								className={cx(styles.formInputGroup, styles.formInputGroupMarginTop, (this.isFieldValid('confirmed') || this.state.invalidFields.confirmed) && styles.usernameFieldError)}>
								<Input
									type="password"
									name="confirmed"
									placeholder="Re-Password"
									value={this.state.confirmed}
									className={cx(styles.formInputControl)}
									onChange={(event => this.handleInputChange(event))}
								/>
								<div className={styles.errorMessage}>{this.getValidationError('confirmed')}</div>
							</div>
							<div className={styles.formActionContainer}>
								<Button
									onClick={() => this.performUpdatepassword()}
									className={cx(styles.loginFormBtn)}
									loading={this.props.loading}
								>
									{('Submit')}
								</Button>
							</div>
							<div className={styles.forgotPasswordWrap}>
								<Link to="/login" className={cx(styles.formLink)}>Back to Login</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
